module.exports = __webpack_public_path__ + "static/media/we_code.d08a26b4.svg";